// Browser translate features (and translate extensions) rewrite text nodes
// live by moving/replacing them in place, out from under React's own
// reconciler. When React later tries to remove or reorder a node that
// translate has already relocated, the native DOM call throws instead of
// silently failing — this is a documented React/browser-translate
// incompatibility. `translate="no"` in index.html asks browsers not to
// translate the page, but that hint isn't reliably honored everywhere
// (tracked upstream as Chromium issue 329233123), and iOS browsers hit the
// same race in a different shape (see the /signup crash reports this patch
// followed from). This makes the two calls React relies on resilient
// instead: if the node isn't where the caller expects, no-op rather than
// throw, and let React's virtual DOM stay the source of truth.
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
